import { refundMethods } from '@reveni-io/reveni-ui'

import { providers } from '@/returns/constants'

import { refundMethods as refundMethodFilters } from './constants'

export const getRefundMethods = provider => {
  return refundMethodFilters.filter(r => {
    if (r.value === refundMethods.giftCard) return provider === providers.shopify

    return true
  })
}
